<template>
  <div  v-if="show_body">
    <!-- 测评答题 -->
    <answer-questions v-if="data.list"  :array="data.list" :cid_type= 'zycp' :interruptShow="interruptShow" :data_="data"  @interruptHandle="interruptHandle" :intro="data.intro?data.intro.split('\r'):[]" @saveReportHandle="saveReportHandle"></answer-questions>
  </div>
</template>
<script>
import { sale_ceping71_index,sale_ceping71_answer} from '@/api/measurement'
import { shareCon} from "@/utils/wxconfig";
import { phoneValidation} from '@/utils/validation'
import AnswerQuestions from "@c/measurement/answer-questions";
// import AnswerCollect from "@c/measurement/answer-collect";

export default {
  data() {
      return {
        show_body: false,
        list: [],
        data: {},
        // 上一页面路由
        formPath: '',
        interruptShow:false,
        // 存储答题数据
        queArr:[]
      }
    },
    components:{
      AnswerQuestions,
      // AnswerCollect,
    },
    methods: {
      interruptHandle(bool){
        this.interruptShow = bool;
      },
      // 提交个人信息和答题数据
      saveUserInfo(){
        let q = this.$route.query;
        if(!q.name || !q.phone){
          this.$toast('姓名和手机号不能为空！');
          return
        }
        
        if(!phoneValidation(q.phone)){
          this.$toast('手机号格式错误！');
          return
        }
        let obj = {
          answer: JSON.stringify(this.queArr),
          name:q.name,
          phone:q.phone
        };
        
        this.$toast.loading({
          mask: true,
          message: "提交中..."
        });
        // 
        sale_ceping71_answer(obj).then((data) => {
          // 隐藏提交信息窗口
            
            this.$toast('提交成功！');
            setTimeout(() => {
              if(this.formPath==='/zycp_report'){
                  this.$router.back(); 
                }else{
                  this.$router.push({
                      path: '/zycp_report',
                      query: {
                          cid: q.cid,
                          evaluation_id:data.evaluation_id,
                          md5: data.md5,
                          method:'nologin'
                      }
                  })
                }
            }, 200)
        });
      },
      /*
       *@param: 
       *@return: 
       *@Description: 获得提交的答题数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-01 15:28:13
      */
      saveReportHandle(arr){
          this.queArr = arr;
          this.saveUserInfo();
        
      },
      /*
       *@param: 
       *@return: 
       *@Description: 数据初始化
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-01 15:27:41
      */
      pullData() {
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
        let q = this.$route.query;
        let obj = {};
        sale_ceping71_index(obj).then((data) => {
            if (data.code == 10002) {
              if (this.formPath === '/zycp_report') {
                this.$router.back();
              } else {
                // 已经测评完成
                this.$router.push({
                  path:'/zycp_report',
                  query:this.$route.query
                });
              }

            } else {
              this.data = data;
              document.title = data.headtitle;
            
              this.show_body = true;
             

              shareCon("zycp", this);
            }
            //关闭加载中
            this.$emit('loadingHandle',false);
          })
      },
    },
    /*
     *@param: 
     *@return: 
     *@Description: 获取上一个页面的路由
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-01 15:27:53
    */
    beforeRouteEnter(to, from, next) {
      next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.formPath = from.path;
      })
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>



</style>

